module.exports = __webpack_public_path__ + "img/loading.717a1cf3.gif";